import dayjs from "dayjs";
import ja from "dayjs/locale/ja";
import * as holiday_jp from "@holiday-jp/holiday_jp";

dayjs.locale(ja);

const getDayText = () => (date: Date) => {
  if (holiday_jp.isHoliday(date)) return "text-[#c82525]";

  switch (dayjs(date).day()) {
    case 0:
      return "text-[#c82525]";
    case 6:
      return "text-[#3834dc]";
    default:
      return "text-[#393940]";
  }
};

export default getDayText;
